export const TECHNOLOGY_LOAD_SYSTEM = 'TECHNOLOGY_LOAD_SYSTEM'
export const TECHNOLOGY_LOAD_WORKFLOW = 'TECHNOLOGY_LOAD_WORKFLOW'
